import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const MaterialsQuery = graphql(/* GraphQL */ `
  query materials($offset: Int, $limit: Int) {
    materials(offset: $offset, limit: $limit) {
      ...MaterialsPaged
    }
  }
`);
